import type { MeetingType, MeetingTypePayloadData } from '../../types';

import { AxiosError } from 'axios';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { App } from 'antd';

import { axiosClient } from '@/lib/axios';
import { queryClient } from '@/lib/react-query';

type Payload = {
  companyID: number;
  body: MeetingTypePayloadData;
};

export const addMeetingType = async ({ companyID, body }: Payload): Promise<{ data: MeetingType }> => {
  const { data } = await axiosClient.post<{ data: MeetingType }>(
    `/companies/${companyID}/meetings/meeting-types`,
    body,
  );
  return data;
};
type UseAddMeetingTypeOptions = {
  config?: Partial<UseMutationOptions<{ data: MeetingType }, AxiosError<{ message: string }>, Payload>>;
  postSuccess?: (meetingTypeData: MeetingType) => void;
};

export const useAddMeetingType = ({ config, postSuccess }: UseAddMeetingTypeOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.message,
      });
    },
    onSuccess: async (meetingTypeData) => {
      await queryClient.invalidateQueries({
        queryKey: ['meeting-types'],
      });
      toaster.success({
        message: 'Added Successfully',
        description: 'Meeting Type Added Successfully',
      });
      postSuccess?.({ ...meetingTypeData.data });
    },
    ...config,
    mutationFn: addMeetingType,
  });
};
